// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cart2[data-v-66f77538]{position:sticky;top:80px}.fade-enter[data-v-66f77538],.fade-leave-to[data-v-66f77538]{opacity:0}.fade-enter-active[data-v-66f77538],.fade-leave-active[data-v-66f77538]{transition:opacity .5s}.carts-layer-counter[data-v-66f77538]{overflow:visible;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
